import gql from 'graphql-tag';

export const LOGOUT_USER = gql`
  mutation {
    logout {
      name
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/auth/logout.js